if (!Map.groupBy) {
  Map.groupBy = function (iterable, keyFn) {
    const map = new Map()

    for (const item of iterable) {
      const key = keyFn(item)

      if (!map.has(key)) {
        map.set(key, [])
      }

      map.get(key).push(item)
    }

    return map
  }
}
